<div class="loader" *ngIf="!showloader">
    <img src="assets/images/loader.gif" alt="">
</div> 

<div id="createTick" class="float-right" *ngIf="!userSer.isRestrictedAgent()">
    <a href="javascript:void(0)" [routerLink]="['/add-ticket']" >
        Create Ticket
    </a>
</div>

<div id="greeting" class="flex-cell" *ngIf="!userSer.isAgent()">
    <div id="hello">
        <span>Ask an Attorney</span>
    </div>
    <div id="welcomeBack">
        <span>Take a look at your tickets!</span>
    </div>
</div>


<div class="card-test">

    <div class="card-body-test">
        <!-- <div class="btn-group d-none d-md-block">
            <a class="btn btn-secondary fa fa-ticket" aria-hidden="true"
                [ngClass]="{ 'active': selected_status == null }"
                href="javascript:void(0)" (click)="changeTicStatus()">
                All Tickets {{this.allTickets}}</a>
            <a class="btn btn-secondary fa fa-spinner" aria-hidden="true"
                [ngClass]="{ 'active': selected_status == 1 }"
                href="javascript:void(0)" (click)="changeTicStatus(1)">
                New Tickets {{this.unassignedTicket}}</a>
            <a class="btn btn-secondary fa fa-envelope-open" aria-hidden="true"
                [ngClass]="{ 'active': selected_status == 2 }"
                href="javascript:void(0)" (click)="changeTicStatus(2)">
                Active Tickets {{this.unsolvedTicket}}</a>
            <a class="btn btn-secondary fa fa-envelope rounded-right" aria-hidden="true"
                [ngClass]="{ 'active': selected_status == 3 }"
                href="javascript:void(0)" (click)="changeTicStatus(3)">
                Closed Tickets {{this.solvedTicket}}</a>
            <div class="ml-3 d-inline">&nbsp;</div>
            <a class="btn btn-default fa fa-plus-circle rounded-left" aria-hidden="true"
                href="javascript:void(0)" [routerLink]="['/add-ticket']" routerLinkActive="active">
                Add Ticket</a>
        </div> -->

        <!-- <div class="btn-group-vertical d-sm-block d-md-none">
            <a class="btn btn-secondary fa fa-ticket" aria-hidden="true"
                [ngClass]="{ 'active': selected_status == null }"
                href="javascript:void(0)" (click)="changeTicStatus()">
                All Tickets {{this.allTickets}}</a>
            <a class="btn btn-secondary fa fa-spinner" aria-hidden="true"
                [ngClass]="{ 'active': selected_status == 1 }"
                href="javascript:void(0)" (click)="changeTicStatus(1)">
                New Tickets {{this.unassignedTicket}}</a>
            <a class="btn btn-secondary fa fa-envelope-open" aria-hidden="true"
                href="javascript:void(0)" (click)="changeTicStatus(2)"
                [ngClass]="{ 'active': selected_status == 2 }">
                Active Tickets {{this.unsolvedTicket}}</a>
            <a class="btn btn-secondary fa fa-envelope active" aria-hidden="true"
                [ngClass]="{ 'active': selected_status == 3 }"
                href="javascript:void(0)" (click)="changeTicStatus(3)">
                Closed Tickets {{this.solvedTicket}}</a>
            <a class="btn btn-secondary fa fa-plus-circle" aria-hidden="true"
                href="javascript:void(0)" [routerLink]="['/add-ticket']" routerLinkActive="active">
                Add Ticket</a>
        </div> -->


        <div *ngIf="userSer.isAgentOrGreater( curr_user_id.RoleType )" class="form-row mt-2">
            <label class="col-sm-2 control-label mt-1">Search All Tickets</label>                                    
            <!-- <div class="ticket-search"> -->
            <div class="form-group col-sm-4">
                <input class="form-control" (change)="searchTickets($event)" value="{{this.filter.search}}" />
            </div>                
        </div>
    </div>
</div>


<div id="ticket-tabs">
    <div class="tab" [ngClass]="selected_status === 2 ? 'selected' : null" (click)="selectMe($event)" 
        data-toggle="collapse" data-target="#openTickets">
        Open Tickets
    </div>
    <div class="tab" [ngClass]="selected_status === 3 ? 'selected' : null" style="margin-left: -18px;"  (click)="selectMe($event)" 
        data-toggle="collapse" data-target="#closedTickets">
        Closed Tickets
    </div>
</div>
<div class="tickets-table" [ngClass]="userSer.isAgent() ? 'bigTable' : null">
    <div class="tickets-header">
        <div class="d-block">
            <div class="head" [ngClass]="userSer.isAgent() ? 'admin' : 'client'" *ngFor="let header of row_header; let i = index" (click)="tableSort(i)">
                <span>{{header.text}}</span>
                <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i>    
            </div>
        </div>
        <div *ngIf="userSer.isAgent()" class="d-block float-left">
            <div class="head admin">
                <input (change)="filterByTicketNumber($event)" value={{this.filter.ticket_number}}/>
            </div>
            
            <div class="head admin selects">
                <input (change)="filterSearchSubject($event)" value={{this.filter.subject}}/>
            </div>
            <div class="head admin selects">
                <select (change)="filterBySubjectMatter($event)">
                    <option value="">--- Filter ---</option>
                    <option id="{{slist.ID}}" value="{{slist.ID}}" 
                            [selected]="slist.ID == this.filter.subject_matter"
                            *ngFor="let slist of subject">{{slist.Value}}</option>
                </select>
            </div>
            <div class="head admin selects">
                <select (change)="filterByClient($event)">
                    <option value="">--- Filter ---</option>
                    <option [value]="missingFilter" [selected]="filter.client_missing == 1">Unknown client</option>
                    <option id="{{client.ID}}" value="{{client.ID}}" 
                        [selected]="client.ID == this.filter.client"
                        *ngFor="let client of clients">{{client.ClientName}}
                    </option>
                </select>
            </div>
            <div class="head admin selects" >
                <select (change)="filterByRequester($event)">
                    <option value="">--- Filter ---</option>                                  
                    <option [value]="missingFilter" [selected]="filter.requester_missing == 1">Unknown requester</option>
                    <option value="" disabled *ngIf="!filter.client && !users?.length">Choose a client to list its requesters</option>
                    <option value="{{usr.UserID}}" *ngFor="let usr of users"
                        [selected]="usr.UserID == this.filter.requester">
                        {{usr?.FirstName}} {{usr?.LastName}}
                    </option>
                </select>
            </div>
            <div class="head admin selects">
                <select (change)="filterByAssigned($event)">
                    <option value="">--- Filter ---</option>
                    <option [value]="missingFilter" [selected]="filter.assigned_missing == 1">Unknown attorney</option>
                    <option id="{{assign_user.UserID}}" value="{{assign_user.UserID}}" 
                        [selected]="assign_user.UserID == this.filter.assigned_to"
                        *ngFor="let assign_user of assignedUser">
                        {{assign_user?.FirstName}} {{assign_user?.LastName}}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div class="tickets-body" [ngClass]="userSer.isAgent()? 'bigBody' : null">
        <ng-container *ngFor="let tkt of tickets">
            <div class="tickets-row" (click)="openTicket(tkt.id)">
                <div class="cell" [ngClass]="userSer.isAgent() ? 'admin' : 'client'" >
                    <a href="javascrpt:void(0);" [routerLink]="['/ticket',tkt.id,'edit']">{{tkt.id}}</a>
                </div>
                <div class="cell" [ngClass]="userSer.isAgent() ? 'admin' : 'client'" >
                    <img class="status-icon" src="assets/images/status-ok.svg" alt="" *ngIf="tkt.status==2">
                    <img class="status-icon" src="assets/images/status-open.svg" alt="" *ngIf="tkt.status==3">
                    <img class="status-icon" src="assets/images/status-neutral.svg" alt="" *ngIf="tkt.status==1">
                    <a href="javascrpt:void(0);" [routerLink]="['/ticket',tkt.id,'edit']">
                        <span class="ticket-subject">{{tkt.subject}}</span>
                    </a>
                </div>

                <div class="cell" [ngClass]="userSer.isAgent() ? 'admin' : 'client'" >
                    <a href="javascrpt:void(0);" [routerLink]="['/ticket',tkt.id,'edit']">
                        {{ subjectMatterLabel(tkt) }}
                    </a>
                </div>
                    
                <div class="cell" [ngClass]="userSer.isAgent() ? 'admin' : 'client'"  *ngIf="userSer.isAgent()">
                    <a href="javascrpt:void(0);" [routerLink]="['/ticket',tkt.id,'edit']">{{ clientLabel(tkt) }}</a>
                </div>
                
                <div class="cell" [ngClass]="userSer.isAgent() ? 'admin' : 'client'">
                    <a href="javascrpt:void(0);" [routerLink]="['/ticket',tkt.id,'edit']">{{ requesterLabel(tkt) }}</a>
                </div>

                <div class="cell" [ngClass]="userSer.isAgent() ? 'admin' : 'client'" > 
                    {{ assignedLabel(tkt) }}
                </div>
                <div class="cell" [ngClass]="userSer.isAgent() ? 'admin' : 'client'" >
                    {{tkt.created_at | date:'MMM dd/yy hh:mma'}}
                </div>
                <div *ngIf="userSer.isAgent()" class="cell admin">
                    {{tkt.updated_at | date:'MMM dd/yy hh:mma'}}
                </div> 
            </div>

        </ng-container>

    </div>






        <!-- table-striped  -->
    <!-- <div class="table-responsive">
        <table class="table ticket-table">
            <thead class="thead-light-test">
                <tr>
                    <th scope="col" *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                        <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                        <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                        <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i> {{header.text}}
                    </th>
                    <th scope="col">Action</th>
                </tr>
                <tr *ngIf="userSer.isAdmin()">
                    <th scope="col">
                        <div class="ticketid-search">
                            <input (change)="filterByTicketNumber($event)" value={{this.filter.ticket_number}}/>
                        </div>
                    </th>
                    
                    <th  scope="col">
                        <div class="subject-search">
                            <input (change)="filterSearchSubject($event)" value={{this.filter.subject}}/>
                        </div>
                    </th>
                    <th scope="col">
                        <div class="select-options subjectMatter">
                            <select (change)="filterBySubjectMatter($event)">
                                <option value="">--- Filter ---</option>
                                <option id="{{slist.ID}}" value="{{slist.ID}}" 
                                        [selected]="slist.ID == this.filter.subject_matter"
                                        *ngFor="let slist of subject">{{slist.Value}}</option>
                            </select>
                        </div>
                    </th>
                    <th scope="col" *ngIf="userSer.isCrazyListForSearch( curr_user_id.RoleType )">
                        <div class="select-options">
                            <select (change)="filterByClient($event)">
                                <option value="">--- Filter ---</option>
                                <option [value]="missingFilter" [selected]="filter.client_missing == 1">Unknown client</option>
                                <option id="{{client.ID}}" value="{{client.ID}}" 
                                    [selected]="client.ID == this.filter.client"
                                    *ngFor="let client of clients">{{client.ClientName}}
                                </option>
                            </select>
                        </div>
                    </th>
                    <th  scope="col" *ngIf="userSer.isCrazy2ListForFilter( curr_user_id.RoleType )">
                        <div class="select-options">
                            <select (change)="filterByRequester($event)">
                                <option value="">--- Filter ---</option>                                  
                                <option [value]="missingFilter" [selected]="filter.requester_missing == 1">Unknown requester</option>
                                <option value="" disabled *ngIf="!filter.client && !users?.length">Choose a client to list its requesters</option>
                                <option value="{{usr.UserID}}" *ngFor="let usr of users"
                                    [selected]="usr.UserID == this.filter.requester">
                                    {{usr?.FirstName}} {{usr?.LastName}}
                                </option>
                            </select>
                        </div>
                    </th>
                    <th scope="col">
                        <div class="select-options">
                        <select (change)="filterByAssigned($event)">
                            <option value="">--- Filter ---</option>
                            <option [value]="missingFilter" [selected]="filter.assigned_missing == 1">Unknown attorney</option>
                            <option id="{{assign_user.UserID}}" value="{{assign_user.UserID}}" 
                                [selected]="assign_user.UserID == this.filter.assigned_to"
                                *ngFor="let assign_user of assignedUser">
                                {{assign_user?.FirstName}} {{assign_user?.LastName}}
                            </option>
                        </select>
                        </div>
                    </th>
                    <th scope="col">
                    </th>
                    <th scope="col">&nbsp;</th>
                    <th scope="col">&nbsp;</th>
                </tr>
            </thead>

            <tbody>
                <ng-container *ngFor="let tkt of tickets">
                    <tr scope="row">
                        <td>
                            <a href="javascrpt:void(0);" [routerLink]="['/ticket',tkt.id,'edit']">{{tkt.id}}</a>
                        </td>
                        <td>
                            <img class="status-icon" src="assets/images/status-ok.svg" alt="" *ngIf="tkt.status==2">
                            <img class="status-icon" src="assets/images/status-open.svg" alt="" *ngIf="tkt.status==3">
                            <img class="status-icon" src="assets/images/status-neutral.svg" alt="" *ngIf="tkt.status==1">
                            <a href="javascrpt:void(0);" [routerLink]="['/ticket',tkt.id,'edit']"><span class="ticket-subject">{{tkt.subject}}</span></a>
                        </td>
        
                        <td>
                            <a href="javascrpt:void(0);" [routerLink]="['/ticket',tkt.id,'edit']">{{ subjectMatterLabel(tkt) }}</a>
                        </td>
                            
                        <td *ngIf="userSer.isCrazyListForSearch( curr_user_id.RoleType )">
                            <a href="javascrpt:void(0);" [routerLink]="['/ticket',tkt.id,'edit']">{{ clientLabel(tkt) }}</a>
                        </td>
                        
                        <td *ngIf="userSer.isCrazy2ListForFilter( curr_user_id.RoleType )">
                            <a href="javascrpt:void(0);" [routerLink]="['/ticket',tkt.id,'edit']">{{ requesterLabel(tkt) }}</a>
                        </td>

                        <td> {{ assignedLabel(tkt) }}</td>
                        <td>{{tkt.created_at | date:'mmm-dd-yy hh:mma'}}</td>
                        <td *ngIf="!is_deleted_selected">{{tkt.updated_at | date:'hh:mma MM/dd/yyyy'}}</td>
                        <td *ngIf="is_deleted_selected">{{tkt.deleted_at | date:'hh:mma MM/dd/yyyy'}}</td>

                        <td>
                            <div ngbDropdown placement="bottom-right" class="d-inline-block">
                                <button class="" id="dropdownBasic1" ngbDropdownToggle><i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                                </button>
                                <div class="right" ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                    <button *ngIf="tkt.status==3 && is_deleted_selected == false" class="dropdown-item" (click)="changeStatus(tkt.id,2)">ReOpen</button>
                                    <button *ngIf="tkt.status==2 && is_deleted_selected == false" class="dropdown-item" (click)="changeStatus(tkt.id,3)">Closed</button>
                                    <button *ngIf="tkt.status==1 && is_deleted_selected == false" [routerLink]="['/ticket',tkt.id,'edit']" class="dropdown-item">Assign</button>
                                    <button *ngIf="is_deleted_selected == false" class="dropdown-item" [routerLink]="['/ticket',tkt.id,'edit']">Edit</button>
                                    <button *ngIf="curr_user_id.UserType == 1 && is_deleted_selected == false" class="dropdown-item" (click)="deleteTicket(tkt.id)">Delete</button>
                                    <button *ngIf="curr_user_id.UserType == 1 && is_deleted_selected == true" class="dropdown-item" (click)="deleteTicket(tkt.id)">Restore</button>
                                </div>
                            </div>
                        </td>
                    </tr>

                </ng-container>
            </tbody>

            <ng-container *ngIf="tickets?.length == 0">
                <tr><td colspan="8">No Result Found</td></tr>
            </ng-container>

        </table> -->


        <div class="d-block pager" >
            <div class="has-text-centered align-items-end">
                <ul *ngIf="pager.pages && pager.pages.length && pager.pages.length>1" class="pagination">
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
</div>